module.exports = __webpack_public_path__ + "static/media/gts20.181fc04f.png";